export const AD_TESTING_COOKIE = 'angel_ad_testing'
export const AUTH_JWT_COOKIE = 'angel_jwt'
export const AUTH_SESSION_COOKIE = 'angelSession'
export const AUTH_SESSION_COOKIE_0 = 'angelSession.0'
export const CONTENT_SHARED_ID = 'content_shared_id'
export const EARLY_ACCESS_COOKIE = '_angel_early_access'
export const ENABLE_BETA_LANGUAGE_COOKIE = 'ANGEL_BETA_LANGUAGE'
export const EVERFLOW_TRANSACTION_ID_COOKIE = '_ef_transaction_id'
export const FULL_STORY_ENABLED_COOKIE = 'angel_fs_enabled_v2'
export const GUILD_SIGNUP_OFFER_ID_COOKIE = 'guild_signup_offer_id'
export const GUILD_SIGNUP_PROMO_CODE_COOKIE = 'guild_signup_promo_code'
export const LOGIN_STARTED_ORIGIN = 'login_started_origin'
export const LOGIN_USER_EMAIL = 'login_user_email'
export const LOGIN_REDIRECT_URL = 'login_redirect_url'
// Gifted Guild flow markers
export const GIFTED_GUILD_FLOW = 'gifted_guild_flow'
export const GIFTED_INVITATION_ID = 'gifted_invitation_id'
export const REGION_COOKIE = 'angel_region'
export const SEGMENT_ANONYMOUS_ID_COOKIE = 'ajs_anonymous_id'
export const ANGEL_COOKIE_DOMAIN = '.angel.com'
export const SEGMENT_USER_ID_COOKIE = 'ajs_user_id'
export const SEPARATE_TIER_INTERVAL = 'separate_tier_interval'
export const UPDATED_LEGAL_DOCUMENTS = 'angel_legal_docs'
export const ANONYMOUS_ID_HEADER = 'x-anonymous-id'
